import { t } from '@hefe/i18n';
import { BasketballEventUserRoleType } from '@hefe/models';
import {
  BasketballEventColor,
  BasketballEventIcon,
  BasketballRoleIcon,
} from '@hefe/ui';
import { Avatar, Badge, Tooltip } from 'antd';
import styles from './event-role-icon.component.module.scss';

export interface EventRoleIconComponentProps {
  size?: string | number;
  eventType: BasketballEventUserRoleType;
  asAvatar?: boolean;
  withTooltip?: boolean;
  tooltipUsername?: string;
  tooltipText?: string;
}

export default function EventRoleIconComponent(
  props: EventRoleIconComponentProps
) {
  let Icon: any, backgroundColor: string, tooltipText;
  switch (props.eventType) {
    case BasketballEventUserRoleType.JUDGE:
      Icon = BasketballEventIcon.JUDGE;
      backgroundColor = BasketballEventColor.JUDGE;
      tooltipText = t('judges.singular');
      break;
    case BasketballEventUserRoleType.REFEREE:
      Icon = BasketballEventIcon.REFEREE;
      backgroundColor = BasketballEventColor.REFEREE;
      tooltipText = t('referees.singular');
      break;
    case BasketballEventUserRoleType.SUPERVISOR:
      Icon = BasketballEventIcon.VISOR;
      backgroundColor = BasketballEventColor.TASK;
      tooltipText = t('visor');
      break;
    case BasketballEventUserRoleType.JERSEYS:
      Icon = BasketballEventIcon.JERSEYS;
      backgroundColor = BasketballEventColor.JERSEYS;
      tooltipText = t('jerseys');
      break;
    case BasketballEventUserRoleType.TASK:
      Icon = BasketballEventIcon.TASK;
      backgroundColor = BasketballEventColor.TASK;
      tooltipText = t('task');
      break;
    default:
      Icon = BasketballEventIcon.DEFAULT;
      backgroundColor = BasketballEventColor.GAME;
      tooltipText = t('event');
      break;
  }

  tooltipText = props.tooltipText || tooltipText;

  let returnValue;

  if (props.asAvatar) {
    if (false) {
      // TODO Add Badges?!?!
      returnValue = (
        <Badge
          count={
            <BasketballRoleIcon.COACH
              color="white"
              className={styles['avatar-badge']}
            />
          }
          offset={[-35, 5]}
        >
          <Avatar
            shape="square"
            style={{ backgroundColor, borderRadius: 5 }}
            icon={<Icon size={18} />}
          />
        </Badge>
      );
    } else {
      returnValue = (
        <Avatar
          shape="square"
          style={{ backgroundColor, borderRadius: 5 }}
          icon={<Icon size={18} />}
        />
      );
    }
  } else {
    returnValue = (
      <div
        className={styles['container']}
        style={{ backgroundColor: backgroundColor }}
      >
        <Icon size={18} />
      </div>
    );
  }

  if (props.withTooltip) {
    return <Tooltip title={tooltipText}>{returnValue}</Tooltip>;
  } else {
    return returnValue;
  }
}
